import { BaseModel, RecursivePartial } from '@models/base';

export class VzSystemLicenseModule extends BaseModel {
    active?: boolean;
    activeTill?: Date;
    options?: any;

    constructor(json?: RecursivePartial<VzSystemLicenseModule>) {
        super(json);
        this.parseVzSystemLicenseModule(json || {});
    }

    parse(json: RecursivePartial<VzSystemLicenseModule>): VzSystemLicenseModule {
        super.parse(json);
        this.parseVzSystemLicenseModule(json);
        return this;
    }

    private parseVzSystemLicenseModule(json: RecursivePartial<VzSystemLicenseModule>): void {
        VzSystemLicenseModule.assignFields<VzSystemLicenseModule>(this, json, ['active', 'options']);
        VzSystemLicenseModule.assignDates<VzSystemLicenseModule>(this, json, ['activeTill']);
    }
}
